// extracted by mini-css-extract-plugin
export var columnItem = "_df-3";
export var columnItemDraggable = "_df-5";
export var dragHandle = "_df-0";
export var dragHandleHovered = "_df-1";
export var dropdown = "_df-6";
export var dropdownContent = "_df-8";
export var dropdownInner = "_df-7";
export var filterDropdownHeader = "_df-9";
export var icon = "_df-2";
export var moveToTopButton = "_df-4";
export var sectionDivider = "_df-a";